// extracted by mini-css-extract-plugin
export default {"errorText":"ErrorText_errorText__Nezwo"};